// Anonymous pages use the System Admin's appearance (TGCLOUD-1844 QA).
//
// A signed-in user gets their group's theme when they sign in. Nobody is
// signed in on the public pages — trial sign-up and confirmation, set
// password / accept an invitation, student registration — so without this
// they fell back to MUI's built-in palette (the magenta #f50057 in
// Dashboard.jsx's createTheme) instead of the colours set in Settings →
// Appearance as System Admin. The login page already did this for itself;
// every anonymous screen now does.
//
// Deliberately a no-op when someone IS signed in, so a group's own theme is
// never swapped out, and when no ThemeContext exists (isolated tests).

import React from 'react';
import axios from 'src/axios';
import { APICONSTANTS } from 'src/components/Constants';
import { ThemeContext, UserContext } from 'src/store/ContextStore';

export default function useSystemDefaultTheme() {
  const themeCtx = React.useContext(ThemeContext);
  const userCtx = React.useContext(UserContext);
  const setTheme = themeCtx?.setTheme;
  const signedIn = !!userCtx?.user?.email;

  React.useEffect(() => {
    if (!setTheme || signedIn) return undefined;
    let alive = true;
    axios
      .get(APICONSTANTS.defaultTheme)
      .then((res) => {
        if (alive && res.data?.theme) setTheme(res.data.theme);
      })
      .catch(() => {
        // Keep whatever theme is already there; never blank the page over it.
      });
    return () => {
      alive = false;
    };
  }, [setTheme, signedIn]);
}
